import { type SessionStatus } from '@heidi/schema/ml-scribe';
import { useAtom } from 'jotai';
import { useCallback, useState } from 'react';
import { selectedStatusesFilterAtom } from '../atoms';

export const useStatusFilter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedStatusesFilter, setSelectedStatusesFilter] = useAtom(
    selectedStatusesFilterAtom
  );

  const handleStatusChange = useCallback(
    (status: SessionStatus) => {
      setSelectedStatusesFilter((prev) => {
        if (prev.includes(status)) {
          return prev.filter((s) => s !== status);
        }
        return [...prev, status];
      });
    },
    [setSelectedStatusesFilter]
  );

  return {
    isOpen,
    setIsOpen,
    selectedStatusesFilter,
    handleStatusChange,
  };
};
